import { Injectable } from '@angular/core';
import { CoachingMaster } from '../model/coaching-master';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, of, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CoachingService {

  constructor(private http: HttpClient) { }

  // v1.0/coaching
  getcoaching(apexId:string): Observable<CoachingMaster> {
    
    let url=`${environment.api.uri}v1.0/coaching?apexid=${apexId}`;
    // let url=`${environment.api.uri}v1.0/performance/month?apexid=${apexId}&kpidate=2024-01`;
    return this.http.get<CoachingMaster>(url);
  }

  // v1.0/coaching/3/attachment
  getCoachingAttachment(coachingId:number): Observable<Blob> {
    // const header = { Accept: "application/octet-stream" };
    const httpOptions = {
      responseType: 'blob' as 'json'
    };
    let url=`${environment.api.uri}v1.0/coaching/${coachingId}/attachment`;
    // let url=`${environment.api.uri}v1.0/performance/month?apexid=${apexId}&kpidate=2024-01`;
    return this.http.get<Blob>(url,httpOptions);
  }

  // v1.0/kpi/others/3/attachment
  getCoachingAttachmentFromDialog(coachingId:number): Observable<string> {
    let url=`${environment.api.uri}v1.0/coaching/${coachingId}/attachment`;
    
    return this.http.get<string>(url, { responseType: 'text' as 'json'});
  }

  // v1.0/kpi/others/3/attachment
  getCoachingAttachmentFromDialogV2(coachingId:number): Observable<any> {
    let url=`${environment.api.uri}v1.0/coaching/${coachingId}/attachment`;
    
    return this.http.get(url, { responseType: 'blob' });
  }


}
